module.exports = __webpack_public_path__ + "fonts/videogular.eot";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/videogular.eot
// module id = ./node_modules/@ps/common-core/dist/fonts/videogular.eot
// module chunks = 1